<template>
  <v-container class="main-container responsive-height">
    <v-row dense>
      <v-col cols="12" xl="5">
        <!-- <WalletBalanceCard></WalletBalanceCard> -->
      </v-col>
      <v-col cols="12" xl="7">
        <!-- <TitleCard></TitleCard> -->
        <v-row dense>
          <v-col cols="12" sm="12">
            <div class="widgets-card-wrapper widgets-card-wrapper--wallet">
              <v-card
              v-for="item in forecast"
                :key="item.day"
                outlined
                tile
                class="widgets-card"
                :to="item.links"
                :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'"
                
              >
                <v-btn
                  class="mx-2 mb-3"
                  fab
                  link
                  small
                  :ripple="false"
                  elevation="0"
                  :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F8F6FC'"
                >
                  <v-icon color="greenMain">
                    {{ item.icon }}
                  </v-icon>
                </v-btn>
                <p class="mb-0">{{ item.day }}</p>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <MiddleBar></MiddleBar>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" xl="12">
        <WalletTabs></WalletTabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WalletBalanceCard from "@/components/PagesComponents/MamWalletPage/WalletBalanceCard.vue";
import MiddleBar from "@/components/PagesComponents/MamWalletPage/MiddleBar.vue";
import TitleCard from "@/components/PagesComponents/MamWalletPage/TitleCard.vue";
import WalletTabs from "@/components/PagesComponents/MamWalletPage/WalletTabs.vue";

export default {
  data: () => ({
    forecast: [
      // { day: "Deposit", icon: "mdi-tray-arrow-down", links: "/deposit" },
      { day: "Investor Profit Withdraw", icon: "mdi-tray-arrow-up", links: "/investor-profit-withdraw" },
      // { day: "Wallet Internal Transfer", icon: "mdi-swap-horizontal", links: "/mam-wallet-internal-transfer" },
    ],
  }),
  components: {
    WalletBalanceCard,
    TitleCard,
    MiddleBar,
    WalletTabs
  },
};
</script>
